// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"330":"593fa14a","596":"fc4faad6","664":"caacaf00","834":"c0628079","873":"64465b0c"}[chunkId] + ".chunk.css";
};